import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class KeyIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 64 64"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="m 28.356336,9.3296214 c -0.09415,2.6672756 2.606105,4.9878116 5.154973,4.0644666 3.305752,-0.994169 3.736999,-6.187182 0.709114,-7.8064022 -2.553557,-1.6344887 -6.038917,0.7721786 -5.864087,3.7419356 z M 16.662885,17.546314 C 16.408107,11.685755 19.31444,5.7379244 24.429828,2.8884724 c 6.31646,-3.9977893 15.10558,-1.7089738 19.63212,4.0412273 5.178296,6.2329333 3.996102,16.3232013 -1.770287,21.7475123 -0.996114,1.647448 -3.561828,1.222845 -3.945984,3.208844 -0.580608,0.979342 -0.719065,2.064737 -0.688259,3.190733 0.566696,2.014331 -2.139003,1.64483 -1.825822,3.786309 0.329082,5.301981 -0.100083,10.612314 -0.20256,15.918659 -0.274668,2.200536 0.649512,4.606761 -0.410259,6.657652 -1.386117,2.341719 -4.078676,2.204711 -5.132369,-0.276721 -1.526111,-1.753004 -4.608135,-3.640963 -3.407762,-6.384708 1.936111,-1.720837 -1.18139,-3.47443 0.240745,-5.116401 2.823908,-1.402463 -1.336038,-2.320705 -0.082,-4.36547 1.713413,-0.984366 1.148335,-2.536261 -0.122327,-3.565574 1.047614,-1.820002 0.828543,-4.903543 -1.432193,-5.984461 0.08422,-1.818314 1.622157,-4.166295 -0.937861,-5.241944 -4.479788,-2.654951 -7.591329,-7.621739 -7.682144,-12.957816 z"
					id="path604"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5,
						stroke: "#000000",
						strokeWidth: 1.29468,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}